var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInPlayGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "27px",
    viewBox: "0 0 24 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-119.000000, -472.000000)",
    fill: "#00000061"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0198509,11.9633282 C29.2714021,13.8579379 30,16.1283651 30,18.5689655 C30,25.1963825 24.627417,30.5689655 18,30.5689655 C11.372583,30.5689655 6,25.1963825 6,18.5689655 C6,12.3548064 10.7234495,7.24386801 16.7758621,6.63063691 L16.7758621,6 L14.3275862,6 L14.3275862,4 L21.2241379,4 L21.2241379,6 L18.7758621,6 L18.7758621,6.5936446 C21.426225,6.76277612 23.8426478,7.79229468 25.748841,9.40591091 L26.9825484,8.17220356 L28.396762,9.58641713 L29.396762,10.5864171 L28.0198509,11.9633282 Z M18,28.5689655 C23.5228475,28.5689655 28,24.091813 28,18.5689655 C28,13.046118 23.5228475,8.56896552 18,8.56896552 C12.4771525,8.56896552 8,13.046118 8,18.5689655 C8,24.091813 12.4771525,28.5689655 18,28.5689655 Z M17.7758621,10.1724138 C22.2586207,10.1724138 25.9655172,13.8793103 25.9655172,18.362069 C25.9655172,22.8448276 22.2586207,26.5517241 17.7758621,26.5517241 C13.2931034,26.5517241 9.5862069,22.8448276 9.5862069,18.362069 L17.7758621,18.362069 L17.7758621,10.1724138 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInPlayGrey);
export default __webpack_public_path__ + "static/media/inPlayGrey.090a5187dbb0acfc75750999442f79ab.svg";
export { ForwardRef as ReactComponent };